import { api } from '@/lib/api';
import type { EventSummary } from './types';

export const EVENTS_KEY = 'eventIntelligence';

// The events list, shared by the events page and the home route's event-mode landing. Kept apart
// from useEvents so the eagerly loaded router doesn't pull in the offline capture runtime.
export const eventsListQuery = (userId: string | undefined) => ({
  queryKey: [EVENTS_KEY, userId],
  queryFn: async () => (await api.get<EventSummary[]>('/events', { headers: { 'X-Meridian-Event-Actor': userId } })).data,
  staleTime: 15_000,
});
